import { Routes, Route, type Location } from 'react-router-dom';
import { Feed } from './Feed';
import { Search } from './Search';

export function ReelsflixRoutes({ location }: { location?: Partial<Location> | string }) {
  return (
    <Routes location={location}>
      <Route path="/reelsflix" element={<Feed />} />
      <Route path="/reelsflix/search" element={<Search />} />
    </Routes>
  );
}
